import React, { memo } from 'react';
import { ReactComponent as IconSVG } from '../../images/logo.svg';
import styles from './Roof.module.scss';
import { Button } from '../../shared/components/Button';

export const Roof = memo(function Roof({
  link,
  price,
}: {
  link: string | null;
  price: number | null;
}) {
  return (
    <section className={styles.section_roof}>
      <div className={styles.container}>
        <IconSVG className={styles.logo} />
        <div className={styles.content}>
          <p className={styles.content_text}>
            Игровой тренажер <br /> для изучения языка с нуля
          </p>
          <div className={styles.label} />
        </div>
        <div className={styles.buy_course}>
          <Button link={link} price={price} btnClassName="orange_btn" text="Купить курс" />
        </div>
      </div>
    </section>
  );
});
